export const initialParameters = {
  form: {
    dailyNumbers: '4',
    exclude: [],
    healthInsurance: 'Todos',
    minAge: '0',
    readjustment: '0%',
    stopLoss: '999999',
    surgicalCare: true,
    testDate: '2018',
    trainingDate: '2016 a 2018',
    hasError: false,
  },
  itens: {
    groups: [],
    sectors: [],
    enabledSectors: [],
    include: [],
    unMarkedGroups: [],
  },
  features: [],
}

export const initialValidation = [
  'dailyNumbers',
  'healthInsurance',
  ['minAge', value => value > 18, value => value < 0],
  'readjustment',
  'stopLoss',
]
